/**
 * Copyright © 2025-2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Sonner } from "@farmlands/shadcn-ui";
import { CssBaseline } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FC } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { AppRoutes } from "./components/AppRouter";
import { RemoteConfigProvider } from "./services/firebase/remote-config";
import PushNotificationsProvider from "./services/push-notifications/PushNotificationsProvider";
import { OnlineStatusProvider } from "./util/useOnlineStatus";
import { PreviousPageProvider } from "./util/usePreviousPage";
import { ToastContainer } from "./util/useToast";

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: false } } });

const router = createBrowserRouter([
  {
    path: "*",
    element: (
      <PreviousPageProvider>
        <PushNotificationsProvider>
          <OnlineStatusProvider>
            <RemoteConfigProvider>
              <ToastContainer />
              <Sonner />
              <CssBaseline />
              <QueryClientProvider client={queryClient}>
                <AppRoutes />
              </QueryClientProvider>
            </RemoteConfigProvider>
          </OnlineStatusProvider>
        </PushNotificationsProvider>
      </PreviousPageProvider>
    ),
  },
]);

export const AppBrowserRouter: FC = () => <RouterProvider router={router} />;
